import styled, { css } from 'styled-components';
import BreadCrumbs from '../../../../shared/components/BreadCrumbs/BreadCrumbs';
import StickyBar from '../../../../shared/components/StickyBar';
import Box from '../../../../shared/spa/core-components/Box';
import { between } from '../../../../shared/spa/core-components/utils/media';
import Navigation from '../../CategoryPage/Navigation';
import Grid from '../../Grid';
import { CategoryHeroConfig } from '../CategoryConfigProvider';
import CTAButton from './CTAButton';
import FeaturedDesigns from './FeaturedDesigns';
import { HeroHeading } from './HeroHeading';

const StyledHeroSection = styled.div`
    overflow: hidden;
`;

const StickyBarContainer = styled.div`
    height: 96px;
    display: flex;
    width: 100%;
`;

const Wrapper = styled.div<{ step: number }>(({ step }) => {
    return css`
        ${between('normal', 'large')} {
            position: relative;
            min-height: 95vh;

            ${step === 1 &&
            css`
                min-height: 975px;
            `}
        }
    `;
});

interface Props {
    categoryKey: string;
    categoryTitle: string;
    hero: CategoryHeroConfig;
    currentSection: string;
}

function HeroSection({ categoryKey, categoryTitle, hero, currentSection }: Props) {
    return (
        <StyledHeroSection>
            <Wrapper step={1}>
                <Grid>
                    <BreadCrumbs
                        breadcrumbs={[
                            {
                                label: __('Home'),
                                path: '/',
                            },
                            {
                                label: categoryTitle,
                            },
                        ]}
                    />
                </Grid>
                <Box paddingTop={['space10', 'space12']}>
                    <HeroHeading hero={hero} categoryKey={categoryKey} />
                </Box>

                <FeaturedDesigns categoryTitle={categoryTitle} hero={hero} isHeroView />
            </Wrapper>

            <StickyBarContainer>
                <StickyBar hide>
                    <StickyBarContainer>
                        <Navigation categoryKey={categoryKey} currentSection={currentSection}>
                            <CTAButton
                                link={hero.interaction.link}
                                buttonColor={hero.interaction.buttonColor}
                                categoryKey={categoryKey}
                                cta_location="sticky nav cta"
                            >
                                {hero.interaction.buttonText}
                            </CTAButton>
                        </Navigation>
                    </StickyBarContainer>
                </StickyBar>
            </StickyBarContainer>
        </StyledHeroSection>
    );
}

export default HeroSection;
